import { render, staticRenderFns } from "./SuccessBanner.vue?vue&type=template&id=98c89a14&"
import script from "./SuccessBanner.vue?vue&type=script&lang=js&"
export * from "./SuccessBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports